import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Skeleton, Typography } from '@mui/material';
import sanitizeHtml from 'sanitize-html';
import { checkVietNam } from '@src/utils/checkCountry';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { getPriceText } from '@src/services/payment';
import { useSelector } from 'react-redux';
import { StyledOrderInfo } from './index.style';
import Order from './Order';

const OrderInfo = ({
  actualPrice,
  remainingValueOfTheCurrentPackage,
  calculateCharacterPurchase,
  currentNumberCharacters,
  totalPrice = 0,
  customPackagePrice,
  orderPackageInfoWhenApplyVoucher,
  creditsOrderData,
  loadingGetPreviewRolloverCredits,
  loadingGetBankAccountInfo,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const { package: packageState, paymentMethod } = useSelector(
    (state) => state.order,
  );

  const skeletonLoading =
    loadingGetPreviewRolloverCredits ||
    loadingGetBankAccountInfo ||
    !packageState;

  const isVietNam = checkVietNam();
  const minPaymentAmountByLanguage = isVietNam
    ? paymentMethod?.minPaymentAmount?.vnd
    : paymentMethod?.minPaymentAmount?.usd;

  const isNotTopUpPackage = packageState?.code && !packageState?.isTopUp;
  const isBelowMinPayment = actualPrice < (minPaymentAmountByLanguage || 0);
  const isShowMinPaymentWarning = isNotTopUpPackage && isBelowMinPayment;

  return (
    <StyledOrderInfo>
      <Order
        remainingValueOfTheCurrentPackage={remainingValueOfTheCurrentPackage}
        calculateCharacterPurchase={calculateCharacterPurchase}
        currentNumberCharacters={currentNumberCharacters}
        customPackagePrice={customPackagePrice}
        orderPackageInfoWhenApplyVoucher={orderPackageInfoWhenApplyVoucher}
        creditsOrderData={creditsOrderData}
        loadingGetPreviewRolloverCredits={loadingGetPreviewRolloverCredits}
      />

      {totalPrice >= 0 && (
        <>
          <Box className="total">
            <Typography className="info-title">
              {t('totalPricePayment')}
            </Typography>
            {skeletonLoading ? (
              <Skeleton
                animation="wave"
                height={30}
                width="20%"
                className="skeleton"
              />
            ) : (
              <Typography className="info-title">
                {!isVietNam && (
                  <span className="discount-unit-price font-size-16">$</span>
                )}
                {isVietNam && (
                  <span className="discount-unit-price underline font-size-16">
                    đ
                  </span>
                )}
                {totalPrice.toLocaleString(language)}
              </Typography>
            )}
          </Box>
          {isShowMinPaymentWarning && (
            <Box className="total">
              <div className="info-min-payment-amount">
                <InfoRoundedIcon className="info-rounded-icon" />
                <div
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(
                      t('minimumPayment', {
                        minimunPrice: getPriceText(
                          minPaymentAmountByLanguage,
                          isVietNam,
                          language,
                        ),
                        actualPrice: getPriceText(
                          actualPrice,
                          isVietNam,
                          language,
                        ),
                      }),
                      {
                        allowedTags: ['strong', 'span'],
                        allowedAttributes: {
                          '*': ['style'],
                        },
                      },
                    ),
                  }}
                />
              </div>
            </Box>
          )}
        </>
      )}
    </StyledOrderInfo>
  );
};

export default OrderInfo;
